/**
 * Utilidades para formateo y manipulación de fechas
 */

/**
 * Formatea una fecha a formato corto (día mes)
 * @param {string|Date} dateString - Fecha en formato ISO string o Date object
 * @param {Object} options - Opciones de formato
 * @returns {string} Fecha formateada
 */
export const formatDate = (dateString, options = {}) => {
  if (!dateString) return "";
  
  const date = dateString instanceof Date ? dateString : new Date(dateString);
  if (isNaN(date.getTime())) return "";

  const defaultOptions = {
    day: "2-digit",
    month: "short",
    ...options
  };

  return date.toLocaleDateString("es-PE", defaultOptions);
};

/**
 * Formatea una fecha con año incluido
 * @param {string|Date} dateString - Fecha en formato ISO string o Date object
 * @returns {string} Fecha formateada con año
 */
export const formatDateWithYear = (dateString) => {
  return formatDate(dateString, {
    day: "2-digit",
    month: "short",
    year: "numeric"
  });
};

/**
 * Obtiene la fecha de hoy en formato ISO (YYYY-MM-DD)
 * @returns {string} Fecha de hoy
 */
export const getTodayDate = () => {
  const today = new Date();
  return today.toISOString().split("T")[0];
};

/**
 * Indica si una fecha (YYYY-MM-DD u ISO) cae en el mes calendario dado (año + mes 1–12).
 * Útil para atribuir aportes a metas (sin monthId) al mes correcto.
 */
export const isDateInCalendarMonth = (dateStr, year, monthNumber) => {
  if (dateStr == null || dateStr === "") return false;
  const s = String(dateStr).trim();
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) {
    const y = Number.parseInt(m[1], 10);
    const mo = Number.parseInt(m[2], 10);
    return y === year && mo === monthNumber;
  }
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return false;
  return d.getFullYear() === year && d.getMonth() + 1 === monthNumber;
};

/**
 * Formatea un timestamp a formato legible
 * @param {number|string} timestamp - Timestamp en milisegundos o ISO string
 * @returns {string} Fecha formateada
 */
export const formatTimestamp = (timestamp) => {
  if (!timestamp) return "";
  const date = typeof timestamp === "number" ? new Date(timestamp) : new Date(timestamp);
  if (isNaN(date.getTime())) return "";
  return date.toLocaleString("es-PE", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  });
};

/**
 * Formatea un día del mes con padding (01, 02, ..., 31)
 * @param {number} day - Día del mes (1-31)
 * @returns {string} Día formateado con padding
 */
export const formatDay = (day) => {
  return String(day).padStart(2, "0");
};
